/*
  Cohérence tapis / personnalisation dans le panier Nafis.

  Invariants tenus côté navigateur :
  - chaque supplément est rattaché à un tapis existant (sinon quantité = 0) ;
  - chaque tapis qui demande une personnalisation a son supplément à la bonne quantité ;
  - une personnalisation SANS _perso_ref n'est jamais rattachée d'office à un tapis :
    elle est signalée et reste supprimable par le client ;
  - le paiement attend que l'interface ET le réseau soient au repos, puis
    re-vérifie l'invariant avant de laisser partir.

  Limite assumée : c'est du JavaScript côté client. Sans Shopify Function
  (app personnalisée), il n'y a aucune garantie serveur.
*/
(function () {
  if (window.__nafisPersoCart) return;

  var cfg = document.getElementById('nafis-perso-config');
  if (!cfg) return;

  window.__nafisPersoCart = true;

  var PERSO_ID = parseInt(cfg.getAttribute('data-perso-product'), 10);
  var PERSO_VARIANT = parseInt(cfg.getAttribute('data-perso-variant'), 10);
  var nativeFetch = window.fetch.bind(window);

  var syncing = null;
  var again = false;
  var pending = 0;
  var quietWaiters = [];
  var lastState = { blocked: false, message: '', unlinked: [] };

  /* le libellé a changé : on lit l'ancien aussi, pour les paniers déjà ouverts */
  function texteDe(props) {
    return props['Personnalisation'] || props['Texte souhaité'] || '';
  }

  /* ---------- suivi des écritures panier en vol ---------- */

  function noteStart() { pending++; }
  function noteEnd() {
    pending = Math.max(0, pending - 1);
    if (pending === 0) {
      var w = quietWaiters; quietWaiters = [];
      w.forEach(function (f) { f(); });
    }
  }
  function whenQuiet() {
    if (pending === 0) return Promise.resolve();
    return new Promise(function (res) { quietWaiters.push(res); });
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- réseau, sans catch silencieux ---------- */

  function post(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var d = null;
        try { d = JSON.parse(t); } catch (e) {}
        if (!r.ok) {
          var m = (d && (d.description || d.message)) || ('HTTP ' + r.status);
          var err = new Error(m); err.status = r.status; throw err;
        }
        return d;
      });
    });
  }

  function readCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('lecture du panier impossible (HTTP ' + r.status + ')');
      return r.json();
    });
  }

  /* Le tiroir de panier est rendu hors de toute .shopify-section : il faut le
     demander explicitement, sinon ses quantités restent figées. */
  function cartSectionIds() {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), function (s) {
      var id = s.id.replace('shopify-section-', '');
      if (id.indexOf('cart') > -1) ids.push(id);
    });
    if (document.querySelector('cart-drawer') && ids.indexOf('cart-drawer') === -1) {
      ids.push('cart-drawer');
    }
    return ids.join(',');
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var el = document.getElementById('shopify-section-' + id);
      var fresh = doc.getElementById('shopify-section-' + id);
      if (el && fresh) { el.innerHTML = fresh.innerHTML; return; }

      if (id === 'cart-drawer') {
        var target = document.getElementById('CartDrawer');
        var src = doc.getElementById('CartDrawer');
        if (target && src) target.innerHTML = src.innerHTML;
      }
    });
  }

  /* ---------- classification ---------- */

  function classify(cart) {
    var mains = {}, mainInfo = {}, persoByRef = {}, unlinked = [];

    (cart.items || []).forEach(function (i) {
      var props = i.properties || {};
      var ref = props._perso_ref;
      if (i.product_id === PERSO_ID) {
        if (!ref) { unlinked.push(i); return; }
        (persoByRef[ref] = persoByRef[ref] || []).push(i);
      } else if (ref) {
        mains[ref] = (mains[ref] || 0) + i.quantity;
        if (!mainInfo[ref]) {
          mainInfo[ref] = { titre: i.product_title || i.title, texte: texteDe(props) };
        }
      }
    });

    var fixes = [], missing = [];

    Object.keys(persoByRef).forEach(function (ref) {
      var cible = mains[ref] || 0;
      persoByRef[ref].forEach(function (l, idx) {
        var q = idx === 0 ? cible : 0;
        if (l.quantity !== q) fixes.push({ key: l.key, qty: q });
      });
    });

    Object.keys(mains).forEach(function (ref) {
      if (!persoByRef[ref] && mains[ref] > 0) {
        missing.push({ ref: ref, qty: mains[ref], info: mainInfo[ref] || {} });
      }
    });

    return { fixes: fixes, missing: missing, unlinked: unlinked };
  }

  /* Un champ quantité situé dans un tiroir fermé n'est pas une intention du
     client : on ne l'attend pas. */
  function inputLive(el) {
    var d = el.closest ? el.closest('cart-drawer') : null;
    if (d && getComputedStyle(d).visibility === 'hidden') return false;
    return true;
  }

  function uiPending(cart) {
    var mismatch = false;
    (cart.items || []).forEach(function (item, idx) {
      var n = idx + 1;
      ['Quantity-' + n, 'Drawer-quantity-' + n].forEach(function (id) {
        var input = document.getElementById(id);
        if (!input || !inputLive(input)) return;
        var v = parseInt(input.value, 10);
        if (!isNaN(v) && v !== item.quantity) mismatch = true;
      });
    });
    return mismatch;
  }

  /* ---------- synchronisation ---------- */

  function runSync() {
    var ids = cartSectionIds();

    return readCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) {
        return { blocked: false, message: '', unlinked: [] };
      }

      var c = classify(cart);
      var chain = Promise.resolve(null);

      c.fixes.forEach(function (f) {
        chain = chain.then(function () {
          return post('/cart/change.js', { id: f.key, quantity: f.qty, sections: ids });
        });
      });

      if (c.missing.length) {
        chain = chain.then(function () {
          var items = c.missing.map(function (m) {
            var p = { '_perso_ref': m.ref };
            p['Personnalisation pour'] = m.info.titre || 'Tapis de prière';
            return { id: PERSO_VARIANT, quantity: m.qty, properties: p };
          });
          return post('/cart/add.js', { items: items, sections: ids });
        });
      }

      return chain
        .then(function (last) {
          if (last && last.sections) applySections(last.sections);
          return readCart();
        })
        .then(function (fresh) {
          var after = classify(fresh);
          var blocked = after.unlinked.length > 0;
          return {
            blocked: blocked,
            message: blocked
              ? 'Votre panier contient une personnalisation qui n’est rattachée à aucun tapis. Retirez-la pour continuer, ou ajoutez le tapis correspondant depuis sa fiche.'
              : '',
            unlinked: after.unlinked
          };
        });
    });
  }

  function sync() {
    if (syncing) { again = true; return syncing; }
    syncing = runSync()
      .then(function (state) { lastState = state; return state; })
      .catch(function (err) {
        lastState = {
          blocked: true, unlinked: [],
          message: 'La vérification de votre panier a échoué : ' + err.message + '. Rechargez la page avant de payer.'
        };
        return lastState;
      })
      .then(function (state) {
        syncing = null;
        decorate();
        render();
        accel(!state.blocked);
        if (again) { again = false; return sync(); }
        return state;
      });
    return syncing;
  }

  /* ---------- stabilisation complète avant paiement ---------- */

  function settle(attempt) {
    attempt = attempt || 0;
    if (attempt > 14) {
      return Promise.resolve({
        blocked: true, unlinked: [],
        message: 'Votre panier n’a pas pu être stabilisé. Rechargez la page avant de payer.'
      });
    }

    return whenQuiet()
      .then(function () { return readCart(); })
      .then(function (cart) {
        if (uiPending(cart)) return wait(350).then(function () { return settle(attempt + 1); });
        return (syncing || sync()).then(function () {
          if (pending > 0) return settle(attempt + 1);
          return readCart().then(function (fresh) {
            var c = classify(fresh);
            if (c.unlinked.length) {
              return {
                blocked: true, unlinked: c.unlinked,
                message: 'Votre panier contient une personnalisation qui n’est rattachée à aucun tapis. Retirez-la pour continuer, ou ajoutez le tapis correspondant depuis sa fiche.'
              };
            }
            if (c.fixes.length || c.missing.length) {
              return wait(200).then(function () { return settle(attempt + 1); });
            }
            return { blocked: false, unlinked: [], message: '' };
          });
        });
      })
      .catch(function (err) {
        return {
          blocked: true, unlinked: [],
          message: 'La vérification de votre panier a échoué : ' + err.message + '. Rechargez la page avant de payer.'
        };
      });
  }

  /* ---------- alerte ---------- */

  function alertBox() {
    var box = document.getElementById('nafis-cart-alert');
    if (box && box.isConnected) return box;
    var host =
      document.querySelector('#main-cart-footer .cart__footer') ||
      document.getElementById('main-cart-items') ||
      document.querySelector('cart-drawer .drawer__inner');
    if (!host) return null;
    box = document.createElement('div');
    box.id = 'nafis-cart-alert';
    box.className = 'nafis-cart-alert';
    box.setAttribute('role', 'alert');
    box.hidden = true;
    host.insertBefore(box, host.firstChild);
    return box;
  }

  function render() {
    var box = alertBox();
    if (!box) return;

    if (!lastState.blocked) { box.hidden = true; box.innerHTML = ''; return; }

    box.innerHTML = '';
    var t = document.createElement('strong');
    t.className = 'nafis-cart-alert__title';
    t.textContent = 'Vérification du panier';
    var p = document.createElement('span');
    p.textContent = lastState.message;
    box.appendChild(t); box.appendChild(p);

    if (lastState.unlinked && lastState.unlinked.length) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nafis-cart-alert__btn';
      b.textContent = 'Retirer cette personnalisation';
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = 'Suppression…';
        var chain = Promise.resolve(null);
        lastState.unlinked.forEach(function (l) {
          chain = chain.then(function () {
            return post('/cart/change.js', { id: l.key, quantity: 0, sections: cartSectionIds() });
          });
        });
        chain
          .then(function (last) { if (last && last.sections) applySections(last.sections); return sync(); })
          .catch(function (err) {
            b.disabled = false; b.textContent = 'Retirer cette personnalisation';
            p.textContent = 'La suppression a échoué : ' + err.message + '. Rechargez la page et réessayez.';
          });
      });
      box.appendChild(b);
    }

    box.hidden = false;
  }

  function accel(on) {
    Array.prototype.forEach.call(
      document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons'),
      function (el) { el.classList.toggle('nafis-accel-off', !on); }
    );
  }

  /* ---------- abandon de la personnalisation ---------- */

  function dropPersonalisation(ref, button) {
    button.disabled = true;
    button.textContent = 'Retrait…';
    var ids = cartSectionIds();

    return readCart()
      .then(function (cart) {
        var persos = [], tapis = [];
        (cart.items || []).forEach(function (i) {
          if ((i.properties || {})._perso_ref !== ref) return;
          if (i.product_id === PERSO_ID) persos.push(i); else tapis.push(i);
        });

        var chain = Promise.resolve(null);
        persos.forEach(function (l) {
          chain = chain.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); });
        });
        tapis.forEach(function (l) {
          chain = chain
            .then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); })
            .then(function () {
              return post('/cart/add.js', { items: [{ id: l.variant_id, quantity: l.quantity }], sections: ids });
            });
        });
        return chain;
      })
      .then(function (last) { if (last && last.sections) applySections(last.sections); return sync(); })
      .catch(function (err) {
        lastState = {
          blocked: true, unlinked: [],
          message: 'Le retrait de la personnalisation a échoué : ' + err.message + '. Vérifiez votre panier avant de payer.'
        };
        render();
        return sync();
      });
  }

  /* ---------- décoration des lignes personnalisation ---------- */

  function applyRow(row, linked, ref) {
    var q = row.querySelector('quantity-input, .quantity');
    var rm = row.querySelector('cart-remove-button');

    if (rm) rm.style.display = linked ? 'none' : '';
    if (q) q.style.display = linked ? 'none' : '';

    var old = row.querySelector('.nafis-perso-note');
    if (old) old.remove();

    var note = document.createElement('div');
    note.className = 'nafis-perso-note';

    var label = document.createElement('p');
    label.className = 'nafis-perso-linked' + (linked ? '' : ' is-warn');
    label.textContent = linked ? 'Quantité liée au tapis personnalisé' : 'Non rattachée à un tapis';
    note.appendChild(label);

    if (linked && ref) {
      var drop = document.createElement('button');
      drop.type = 'button';
      drop.className = 'nafis-perso-drop';
      drop.textContent = 'Retirer la personnalisation';
      drop.addEventListener('click', function () { dropPersonalisation(ref, drop); });
      note.appendChild(drop);
    }

    var host = q ? q.parentNode : row;
    host.insertBefore(note, q || null);
  }

  function decorate() {
    return readCart()
      .then(function (cart) {
        var mains = {};
        (cart.items || []).forEach(function (i) {
          var r = (i.properties || {})._perso_ref;
          if (r && i.product_id !== PERSO_ID) mains[r] = true;
        });
        (cart.items || []).forEach(function (item, idx) {
          if (item.product_id !== PERSO_ID) return;
          var ref = (item.properties || {})._perso_ref || null;
          var linked = !!(ref && mains[ref]);
          var n = idx + 1;
          ['CartItem-' + n, 'CartDrawer-Item-' + n].forEach(function (id) {
            var row = document.getElementById(id);
            if (row) applyRow(row, linked, ref);
          });
        });
      })
      .catch(function () { /* cosmétique : n'influence pas la garde de paiement */ });
  }

  /* ---------- interception ciblée des écritures panier ---------- */

  if (!window.__nafisFetchWrapped) {
    window.__nafisFetchWrapped = true;
    var original = window.fetch;
    window.fetch = function (input) {
      var p = original.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/add') > -1) {
          noteStart();
          p.then(function () { noteEnd(); sync(); }, function () { noteEnd(); });
        }
      } catch (e) { /* ne jamais casser le fetch de l'appelant */ }
      return p;
    };
  }

  /* ---------- garde avant paiement ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout')
      : null;
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    accel(false);

    settle(0).then(function (state) {
      var live = document.getElementById('checkout') ||
                 document.getElementById('CartDrawer-Checkout') ||
                 document.querySelector('button[name="checkout"]') || btn;
      live.disabled = false;
      live.setAttribute('aria-busy', 'false');

      if (state && state.blocked) {
        lastState = state;
        render();
        var box = document.getElementById('nafis-cart-alert');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      accel(true);
      window.location.href = '/checkout';
    });
  }, true);

  /* ---------- démarrage ---------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) sync(); });
})();
